module.exports = __webpack_public_path__ + "img/entrevista.1b621269.svg";